import { configConstants } from "../../../actions/precog/config";

const defaultState = {
  status: {
    started: false,
    ended: false,
    error: false
  },
  data: []
};

export function precogConfig(state = defaultState, { type, payload, error }) {
  switch (type) {
  case configConstants.GET_PRECOG_CONFIG_START:
    return {
      ...state,
      status: {
        started: true,
        ended: false,
        error: false
      }
    };
  case configConstants.GET_PRECOG_CONFIG_SUCCESS:
    return {
      ...state,
      status: {
        started: false,
        ended: true,
        error: false
      },
      data: payload?.data
    };
  case configConstants.GET_PRECOG_CONFIG_ERROR:
    return {
      ...state,
      status: {
        started: false,
        ended: false,
        error: true
      }
    };
  default:
    return state;
  }
}